import { render } from "./PremioSugerenciaComponent.vue?vue&type=template&id=04005be3&scoped=true"
import script from "./PremioSugerenciaComponent.vue?vue&type=script&lang=js"
export * from "./PremioSugerenciaComponent.vue?vue&type=script&lang=js"

import "./PremioSugerenciaComponent.vue?vue&type=style&index=0&id=04005be3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04005be3"]])

export default __exports__